import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { LoadMore, Msg, Button } from 'react-weui';
// import PropTypes from 'prop-types';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import Http from 'services/http2';

//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import { formatDate } from 'lib/formatter.ts';
import CompanyService from 'services/company2';
import ModalService from 'services/modal';
import CustFieldService from 'services/custField';
import User from 'services/user2';
import Util from 'lib/util.js';

function SourcingDetail(props) {
  const Config = {
    purchase: {
      title: '潜在供应商档案',
      apiPath: '/archives/compPotVendor/detail',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Invite_Status',
          subKey: 'inviteStatus',
          value: 'inviteStatusName'
        },
        {
          mainKey: 'B02_Vendor_Status',
          subKey: 'vendorStatus',
          value: 'vendorStatusName'
        },
        {
          mainKey: 'B02_Comp_Business_Form',
          subKey: 'businessForm',
          value: 'businessFormName'
        },
        {
          mainKey: 'B02_Company_Nature',
          subKey: 'companyNature',
          value: 'companyNatureName'
        },
        {
          mainKey: 'B02_vendor_life_cycle',
          subKey: 'lifeCycle',
          value: 'lifeCycleName'
        },
        {
          mainKey: 'B02_Tax_Type',
          subKey: 'taxType',
          value: 'taxTypeName'
        }
      ],
      idField: 'xkUniqueCode',
      wfmCode: '1005'
    }
  };

  const style1 = {
    image: {
      width: 60,
      height: 60,
      fontSize: 60,
      color: '#ddd'
    },
    img: {
      margin: 'auto',
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%'
    },
    paper: {
      padding: 10,
      borderBottom: '1px solid #d9d9d9',
      margin: 'auto',
      maxWidth: '100%',
      marginBottom: 20
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [isShowDetail, setIsShowDetail] = useState(true);
  const [isShowFincial, setIsShowFincial] = useState(false);
  const [isShowCustField, setIsShowCustField] = useState(false);
  const [vendorDetail, setVendorDetail] = useState([]);
  const [serviceAreaList, setServiceAreaList] = useState([]);
  const [prodCategoryName, setProdCategoryName] = useState('');
  const [prodCategoryBuyer, setProdCategoryBuyer] = useState('');
  const [fieldSetting, setFieldSetting] = useState({});

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //处理详情数据
  self.afterGetDetail = async function (data) {
    //审批流需要根据status来判断
    data.status = data.applyStatus;
    await getServiceAreaList(data);
    await getContactsList(data);
    await getVendorCategory(data);
    await getVendorDetail(data);
    await getProdCatgoryConfig(data);
    getFieldSetting(data);
    forceUpdate();
    setDetail(data);
  };

  async function getServiceAreaList(data) {
    if (!companyCode) {
      return;
    }
    let list1 = [];
    list1 = await CompanyService.getCompEnumList(
      companyCode,
      'B2b_supplier_service_area',
      true
    );
    let value = [],
      str = '';
    if (Array.isArray(data.serviceAreaList)) {
      list1.forEach(item => {
        if (data.serviceAreaList.includes(item.id)) {
          value.push(item.text);
        }
      });
      str = value.join(' ');
    }
    setServiceAreaList(str);
  }

  async function getContactsList(data) {
    let postbody = {
      companyCode: companyCode,
      xkUniqueCode: self.id,
      apiPath: '/archives/compPotVendor/contactsList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let contactsList = response.data.list || [];
        contactsList.forEach(item => {
          if (!item.mobileArea) {
            item.mobileArea = '+86';
          }
          if (item.mainFlag === 1) {
            data.mobile = item.mobileArea + ' ' + item.mobile;
            data.email = item.email;
          }
        });
      }
    });
  }

  //获取自定义字段设置
  function getFieldSetting(data) {
    //获取自定义字段
    CustFieldService.getSetting(companyCode, '', true, 87, dispatch).then(
      rs => {
        if (rs) {
          let fieldData = rs;
          if (Array.isArray(fieldData.list)) {
            fieldData.list.forEach(item => {
              //单头单身日期字段，转换为时间戳
              CustFieldService.parseCustFields(
                fieldData,
                data,
                null,
                self.isPurchase
              );
            });
          }
          setFieldSetting(fieldData);
        }
      }
    );
  }

  // 供应商分类
  async function getVendorCategory(data) {
    let postbody = {
      companyCode: companyCode,
      xkUniqueCode: self.id,
      categoryTypeList: ['0001', '0002', '0003', '0004'],
      apiPath: '/archives/vendorCustomizeCategory/getPageList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let vlist = response.data || [];
        vlist.forEach(item => {
          if (item.categoryType === '0001') {
            data.vendorCategory1 = item.categoryName;
          } else if (item.categoryType === '0002') {
            data.vendorCategory2 = item.categoryName;
          } else if (item.categoryType === '0003') {
            data.vendorCategory3 = item.categoryName;
          } else {
            data.vendorCategory4 = item.categoryName;
          }
        });
      }
    });
  }

  async function getVendorDetail(data) {
    let arr = await CompanyService.getCompanyDetailByCode(
      companyCode,
      'detail',
      data.vendorCode
    );
    setVendorDetail(arr);
  }

  // 准入品类设置
  async function getProdCatgoryConfig(data) {
    let companyParamObj = {};
    await CompanyService.getCompanyParamsByCodes(companyCode, [
      'Vendor_prod_category_config'
    ]).then(res => {
      let item = res[0] || {};
      companyParamObj[item.paramCode] = item.paramValue;
      getCategoryList(companyParamObj['Vendor_prod_category_config'], data);
    });
  }

  function getCategoryList(num, data) {
    let categoryGroupNo; //分类组：0：erp分类，1：分类1，2分类2，3分类3
    if (num === '0') {
      categoryGroupNo = '2000';
      data.prodCategoryType = 'erp分类';
    }
    if (num === '1') {
      categoryGroupNo = '2001';
      data.prodCategoryType = '物料分类1';
    }
    if (num === '2') {
      categoryGroupNo = '2002';
      data.prodCategoryType = '物料分类2';
    }
    if (num === '3') {
      categoryGroupNo = '2003';
      data.prodCategoryType = '物料分类3';
    }
    let postbody = {
      companyCode: companyCode,
      categoryTypeList: [categoryGroupNo],
      apiPath: '/archives/customizeCategory/getList'
    };
    Http.post('/api/cloudCenter', postbody).then(async response => {
      if (response.success) {
        if (Array.isArray(response.data)) {
          let materCategoryList = response.data.map(item => {
            return {
              id: item.categoryCode,
              buyerEmpName: item.buyerEmpName
            };
          });
          await getVendorProdCategory(categoryGroupNo, materCategoryList);
        }
      }
    });
  }

  async function getVendorProdCategory(categoryGroupNo, materCategoryList) {
    let postbody = {
      companyCode: companyCode,
      xkUniqueCode: self.id,
      categoryType: categoryGroupNo,
      apiPath: '/archives/vendorProdCategory/queryList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let vendorCategoryList = response.data || [];
        if (vendorCategoryList.length > 0) {
          let vendorCategoryCodeList = vendorCategoryList.map(
            item => item.categoryCode
          );
          let str1 = vendorCategoryList
            .map(item => '(' + item.categoryCode + ')' + item.categoryName)
            .join(' ');
          setProdCategoryName(str1);
          let arr = [];
          vendorCategoryCodeList.forEach(code => {
            materCategoryList.forEach(row => {
              if (row.id === code && row.buyerEmpName) {
                arr.push(row.buyerEmpName);
              }
            });
          });
          let str2 = arr.join(', ');
          setProdCategoryBuyer(str2);
        }
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 审核供应商信息(通过)
  function handleAuditVendor() {
    CompanyService.sourcingAuditVendor(
      companyCode,
      self.id,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  // 审核供应商信息(退回)
  function handleReturnVendor() {
    CompanyService.sourcingReturnVendor(
      companyCode,
      self.id,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className="supplierDetail">
      <TopNav inited={inited} />
      <Paper elevation={0} square={true} style={style1.paper}>
        <Grid container spacing={16}>
          <Grid item>
            <ButtonBase style={style1.image}>
              {detail.vendorLogo ? (
                <img style={style1.img} alt="complex" src={detail.vendorLogo} />
              ) : (
                <i className="icon-supplier"></i>
              )}
            </ButtonBase>
          </Grid>
          <Grid item xs={true} sm container>
            <Grid item xs container direction="column" spacing={16}>
              <Grid item xs>
                <Typography gutterBottom variant="subtitle1">
                  {detail.innerVendorName}
                </Typography>
                <Typography color="textSecondary">
                  {detail.innerVendorAbbr}-{detail.innerVendorCode}
                </Typography>
                <Typography color="textSecondary">
                  携客企业号: {detail.vendorCode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <div className="order-detail-block">
        <div
          className="order-detail-title"
          onClick={() => {
            setIsShowDetail(!isShowDetail);
          }}
        >
          <label>企业信息</label>
          <i
            className={[
              'iconRight',
              isShowDetail ? 'icon-down' : 'icon-more'
            ].join(' ')}
          ></i>
        </div>
        {isShowDetail ? (
          <ul>
            <li>
              <label className="order-detail-label">供应商编码</label>
              <div className="order-detail-value">{detail.innerVendorCode}</div>
            </li>
            <li>
              <label className="order-detail-label">ERP正式编码</label>
              <div className="order-detail-value">{detail.erpFormalCode}</div>
            </li>
            <li>
              <label className="order-detail-label">企业名称</label>
              <div className="order-detail-value">{detail.innerVendorName}</div>
            </li>
            <li>
              <label className="order-detail-label">企业简称</label>
              <div className="order-detail-value">{detail.innerVendorAbbr}</div>
            </li>
            <li>
              <label className="order-detail-label">供应商分类</label>
              <div className="order-detail-value">
                {detail.vendorCategoryName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">经营形态</label>
              <div className="order-detail-value">
                {detail.businessFormName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">公司性质</label>
              <div className="order-detail-value">
                {detail.companyNatureName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">联系邮箱</label>
              <div className="order-detail-value">{detail.email}</div>
            </li>
            <li>
              <label className="order-detail-label">联系电话</label>
              <div className="order-detail-value">{detail.mobile}</div>
            </li>
            <li>
              <label className="order-detail-label">申请类型 </label>
              <div className="order-detail-value">{detail.applyTypeName}</div>
            </li>
            <li>
              <label className="order-detail-label">有效类型</label>
              <div className="order-detail-value">{detail.validTypeName}</div>
            </li>
            <li>
              <label className="order-detail-label">所属区域</label>
              <div className="order-detail-value">{detail.areaName}</div>
            </li>
            <li>
              <label className="order-detail-label">产品描述 </label>
              <div className="order-detail-value">
                {detail.productDescription}
              </div>
            </li>
            <li>
              <label className="order-detail-label">企业地址</label>
              <div className="order-detail-value">{detail.companyAddress}</div>
            </li>
            <li>
              <label className="order-detail-label">携客企业号</label>
              <div className="order-detail-value">
                {vendorDetail.companyCode}
              </div>
            </li>
            <li>
              <label className="order-detail-label">工商注册全称</label>
              <div className="order-detail-value">
                {vendorDetail.companyName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">社会信用代码 </label>
              <div className="order-detail-value">
                {vendorDetail.creditCode}
              </div>
            </li>
            <li>
              <label className="order-detail-label">注册资本</label>
              <div className="order-detail-value">{detail.registCapiName}</div>
            </li>
            <li>
              <label className="order-detail-label">注册法人</label>
              <div className="order-detail-value">{detail.legalPersion}</div>
            </li>
            <li>
              <label className="order-detail-label">注册地 </label>
              <div className="order-detail-value">{detail.address}</div>
            </li>
            <li>
              <label className="order-detail-label">地址-省</label>
              <div className="order-detail-value">
                {detail.provinceNameInfo}
              </div>
            </li>
            <li>
              <label className="order-detail-label">地址-市</label>
              <div className="order-detail-value">{detail.cityNameInfo}</div>
            </li>
            <li>
              <label className="order-detail-label">成立日期</label>
              <div className="order-detail-value">
                {formatDate(detail.companyStartDate)}
              </div>
            </li>
            <li>
              <label className="order-detail-label">生命周期</label>
              <div className="order-detail-value">{detail.lifeCycleName}</div>
            </li>
            <li>
              <label className="order-detail-label">服务区域 </label>
              <div className="order-detail-value">{serviceAreaList}</div>
            </li>
            <li>
              <label className="order-detail-label">关联企业</label>
              <div className="order-detail-value">{detail.assoCompany}</div>
            </li>
            <li>
              <label className="order-detail-label">经营范围</label>
              <div className="order-detail-value">{detail.scopeDesc}</div>
            </li>
            <li>
              <label className="order-detail-label">供应商状态</label>
              <div className="order-detail-value">
                {detail.vendorStatusName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">邀约状态</label>
              <div className="order-detail-value">
                {detail.inviteStatusName}
              </div>
            </li>
            {/* 审批流状态 仅开启后才显示 */}
            {workflow.isActive && (
              <li>
                <label className="order-detail-label">审批环节</label>
                <div className="order-detail-value">
                  <WorkflowStatus
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                  />
                </div>
              </li>
            )}
            {/* 审批流按钮 */}
            {self.isPurchase && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批操作</label>
                <div className="order-detail-value">
                  <WorkflowButtons
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                    onChange={() => {
                      self.getDetail();
                    }}
                  />
                </div>
              </li>
            )}
          </ul>
        ) : (
          ''
        )}
      </div>
      <div className="order-detail-block">
        <div
          className="order-detail-title"
          onClick={() => {
            setIsShowCustField(!isShowCustField);
          }}
        >
          <label>自定义字段</label>
          <i
            className={[
              'iconRight',
              isShowCustField ? 'icon-down' : 'icon-more'
            ].join(' ')}
          ></i>
        </div>
        {isShowCustField ? (
          <ul>
            {fieldSetting.headCustList &&
              fieldSetting.headCustList.map((item, index) => (
                <li key={item.id}>
                  <label className="order-detail-label">{item.transName}</label>
                  <div className="order-detail-value">
                    {detail[item.fieldCode]}
                  </div>
                </li>
              ))}
          </ul>
        ) : (
          ''
        )}
      </div>
      <div className="order-detail-block">
        <div
          className="order-detail-title"
          onClick={() => {
            setIsShowFincial(!isShowFincial);
          }}
        >
          <label>财务信息</label>
          <i
            className={[
              'iconRight',
              isShowFincial ? 'icon-down' : 'icon-more'
            ].join(' ')}
          ></i>
        </div>
        {isShowFincial ? (
          <ul>
            <li>
              <label className="order-detail-label">币别</label>
              <div className="order-detail-value">{detail.currencyName}</div>
            </li>
            <li>
              <label className="order-detail-label">税别</label>
              <div className="order-detail-value">{detail.taxName}</div>
            </li>
            <li>
              <label className="order-detail-label">付款条件</label>
              <div className="order-detail-value">{detail.payWayName}</div>
            </li>
            <li>
              <label className="order-detail-label">付款方式</label>
              <div className="order-detail-value">
                {detail.paymentMethodName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">价格条件</label>
              <div className="order-detail-value">
                {detail.priceConditionName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">信用管控</label>
              <div className="order-detail-value">
                {detail.controlCreditFlag === 0
                  ? '不管控'
                  : detail.controlCreditFlag === 1
                  ? '管控'
                  : ''}
              </div>
            </li>
            <li>
              <label className="order-detail-label">税务类型</label>
              <div className="order-detail-value">{detail.taxTypeName}</div>
            </li>
            <li>
              <label className="order-detail-label">联行号</label>
              <div className="order-detail-value">{detail.unionBankNo}</div>
            </li>
            <li>
              <label className="order-detail-label">银行账号</label>
              <div className="order-detail-value">{detail.bankCardNo}</div>
            </li>
            <li>
              <label className="order-detail-label">发票名称 </label>
              <div className="order-detail-value">{detail.invoiceHeader}</div>
            </li>
            <li>
              <label className="order-detail-label">发票地址</label>
              <div className="order-detail-value">{detail.invoiceAddress}</div>
            </li>
            <li>
              <label className="order-detail-label">开户行</label>
              <div className="order-detail-value">
                {detail.openAccountBankName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">开户地 </label>
              <div className="order-detail-value">
                {(detail.openAccountCountryName || '') +
                  (detail.openAccountProvinceName || '') +
                  (detail.openAccountCityName || '')}
              </div>
            </li>
            <li>
              <label className="order-detail-label">开户名称</label>
              <div className="order-detail-value">{detail.openAccountName}</div>
            </li>
          </ul>
        ) : (
          ''
        )}
      </div>
      <div className="order-detail-block">
        <div className="order-detail-title">
          <label>供应商分类</label>
        </div>
        <ul>
          <li>
            <label className="order-detail-label">分类1</label>
            <div className="order-detail-value">{detail.vendorCategory1}</div>
          </li>
          <li>
            <label className="order-detail-label">分类2</label>
            <div className="order-detail-value">{detail.vendorCategory2}</div>
          </li>
          <li>
            <label className="order-detail-label">分类3</label>
            <div className="order-detail-value">{detail.vendorCategory3}</div>
          </li>
          <li>
            <label className="order-detail-label">绩效分类</label>
            <div className="order-detail-value">{detail.vendorCategory4}</div>
          </li>
        </ul>
      </div>
      <div className="order-detail-block">
        <div className="order-detail-title">
          <label>准入品类类别</label>
        </div>
        <ul>
          <li>
            <label className="order-detail-label">
              {detail.prodCategoryType}
            </label>
            <div className="order-detail-value">{prodCategoryName}</div>
          </li>
          <li>
            <label className="order-detail-label">采购员</label>
            <div className="order-detail-value">{prodCategoryBuyer}</div>
          </li>
        </ul>
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10090106') &&
            [4, 5].includes(detail.inviteStatus) && (
              <Button
                type="default"
                onClick={() => {
                  handleAuditVendor();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                审核
              </Button>
            )}
          {User.checkAuth('10090106') && [4].includes(detail.inviteStatus) && (
            <Button
              type="default"
              onClick={() => {
                handleReturnVendor();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              退回
            </Button>
          )}
        </div>
      )}
      <Modal></Modal>
    </div>
  );
}

SourcingDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SourcingDetail);
